<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';

  import { parseDynamicData } from '$shared/helpers/utils';

  let { value = [] } = $props();
</script>

<div class="comp-simple-array-list-type">
  {#if value?.length !== 0}
    {#each value as item}
      <div class="array-i">{parseDynamicData(item)}</div>
    {/each}
  {:else}
    {EmptyLabelDefault}
  {/if}
</div>

<style>
  .array-i {
    line-height: 20px;
  }
  .array-i:not(:last-child) {
    margin-bottom: 4px;
  }
</style>
